export const formatSpecs = specs => {
    const { fullSpecs = [] } = specs || {};
    if (fullSpecs?.length === 0) {
        return [];
    }

    return fullSpecs.map(spec => {
        const { name, value } = spec || {};
        if (value.length > 1 || value?.[0]?.title === 'Included in Current Configuration') {
            //if more than one value filter those with title "Included in Current Configuration"
            const filteredValues = value.filter(val => val.title === 'Included in Current Configuration');
            return {
                name,
                value: filteredValues.reduce((acc, value) => {
                    const { name } = value || {};
                    return [...acc, ...(name || [])];
                }, []),
            };
        }

        return { name, value };
    });
};
